import { createRouter, createWebHashHistory, RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { initConnection } from "@/core/helpers/signalrHelper";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    path: "/",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/Dashboard.vue")
      },
      {
        path: "/searchResults",
        name: "searchResults",
        component: () => import("@/views/globalSearch/SearchResults.vue")
      },
      //#region job
      {
        path: "/automation/job/list",
        name: "jobList",
        component: () => import("@/views/automation/listFiles/JobList.vue")
      },
      //#endregion job
      //#region process
      {
        path: "/automation/process/list",
        name: "processList",
        component: () => import("@/views/automation/listFiles/ProcessList.vue")
      },
      {
        path: "/automation/process/new",
        name: "addProcess",
        component: () => import("@/views/automation/createFiles/AddProcess.vue")
      },
      {
        path: "/automation/process/:id/edit",
        name: "editProcess",
        component: () => import("@/views/automation/editFiles/EditProcess.vue")
      },
      //#endregion process
      //#region trigger
      {
        path: "/automation/trigger/list",
        name: "triggerList",
        component: () => import("@/views/automation/listFiles/TriggerList.vue")
      },
      {
        path: "/automation/trigger/new",
        name: "addTrigger",
        component: () => import("@/views/automation/createFiles/AddTrigger.vue")
      },
      {
        path: "/automation/trigger/:id/edit",
        name: "editTrigger",
        component: () => import("@/views/automation/editFiles/EditTrigger.vue")
      },
      //#endregion trigger
      //#region log
      {
        path: "/automation/log/list",
        name: "logList",
        component: () => import("@/views/automation/listFiles/LogList.vue")
      },
      {
        path: "/automation/log/:id",
        name: "viewLog",
        component: () => import("@/views/automation/viewFiles/ViewLog.vue")
      },
      //#endregion log
      //#region machine
      {
        path: "/configuration/machine/list",
        name: "machineList",
        component: () => import("@/views/configuration/listFiles/MachineList.vue")
      },
      {
        path: "/configuration/machine/:id/edit",
        name: "editMachine",
        component: () => import("@/views/configuration/editFiles/EditMachine.vue")
      },
      {
        path: "/configuration/machine/new",
        name: "addMachine",
        component: () => import("@/views/configuration/createFiles/AddMachine.vue")
      },
      {
        path: "/configuration/machine/:id",
        name: "viewMachine",
        component: () => import("@/views/configuration/viewFiles/ViewMachine.vue")
      },
      //#endregion machine
      //#region robot
      {
        path: "/configuration/robot/list",
        name: "robotList",
        component: () => import("@/views/configuration/listFiles/RobotList.vue")
      },
      {
        path: "/configuration/robot/:id",
        name: "viewRobot",
        component: () => import("@/views/configuration/viewFiles/ViewRobot.vue")
      },
      //#endregion robot
      //#region environment
      {
        path: "/configuration/environment/list",
        name: "environmentList",
        component: () => import("@/views/configuration/listFiles/EnvironmentList.vue")
      },
      {
        path: "/configuration/environment/:id/edit",
        name: "editEnvironment",
        component: () => import("@/views/configuration/editFiles/EditEnvironment.vue")
      },
      {
        path: "/configuration/environment/new",
        name: "addEnvironment",
        component: () => import("@/views/configuration/createFiles/AddEnvironment.vue")
      },
      {
        path: "/configuration/environment/:id",
        name: "viewEnvironment",
        component: () => import("@/views/configuration/viewFiles/ViewEnvironment.vue")
      },
      {
        path: "/configuration/environment/:id/manage",
        name: "manageEnvironment",
        component: () => import("@/views/configuration/editFiles/ManageEnvironment.vue")
      },
      //#endregion environment
      //#region asset
      {
        path: "/variance/asset/list",
        name: "assetList",
        component: () => import("@/views/variance/listFiles/AssetList.vue"),
      },
      {
        path: "/variance/asset/:id",
        name: "viewAsset",
        component: () => import("@/views/variance/viewFiles/ViewAsset.vue"),
      },
      {
        path: "/variance/asset/new",
        name: "addAsset",
        component: () => import("@/views/variance/createFiles/AddAsset.vue"),
      },
      {
        path: "/variance/asset/:id/edit",
        name: "editAsset",
        component: () => import("@/views/variance/editFiles/EditAsset.vue")
      },
      //#endregion asset
      //#region credential
      {
        path: "/variance/credential/list",
        name: "credentialList",
        component: () => import("@/views/variance/listFiles/CredentialList.vue")
      },
      {
        path: "/variance/credential/new",
        name: "addCredential",
        component: () => import("@/views/variance/createFiles/AddCredential.vue"),
      },
      {
        path: "/variance/credential/:id/edit",
        name: "editCredential",
        component: () => import("@/views/variance/editFiles/EditCredential.vue")
      },
      {
        path: "/variance/credential/:id",
        name: "viewCredential",
        component: () => import("@/views/variance/viewFiles/ViewCredential.vue")
      },
      //#endregion credential
      //#region package    
      {
        path: "/automation/package/list",
        name: "packageList",
        component: () => import("@/views/packaging/listFiles/PackageList.vue")
      },
      {
        path: "/automation/package/:id/view",
        name: "viewPackage",
        component: () => import("@/views/packaging/viewFiles/ViewPackage.vue")
      },
      {
        path: "/automation/package/:id/edit",
        name: "editPackage",
        component: () => import("@/views/packaging/editFiles/EditPackage.vue")
      },
      {
        path: "/automation/package/new",
        name: "addPackage",
        component: () => import("@/views/packaging/createFiles/AddPackage.vue")
      },
      //#endregion package
      //#region queue
      {
        path: "/queueing/queue/list",
        name: "queueList",
        component: () => import("@/views/queueing/listFiles/QueueList.vue")
      },
      {
        path: "/queueing/queue/:id/edit",
        name: "editQueue",
        component: () => import("@/views/queueing/editFiles/EditQueue.vue")
      },
      {
        path: "/queueing/queue/:id/list",
        name: "viewQueue",
        component: () => import("@/views/queueing/viewFiles/ViewQueue.vue")
      },
      {
        path: "/queueing/transaction/:id",
        name: "viewTransactionDetails",
        component: () => import("@/views/queueing/viewFiles/ViewTransaction.vue")
      },
      {
        path: "/queueing/queue/new",
        name: "addQueue",
        component: () => import("@/views/queueing/createFiles/AddQueue.vue")
      },
      //#endregion queue
      //#region supportRequest
      {
        path: "/communication/supportRequest/list",
        name: "supportRequestList",
        component: () => import("@/views/communication/listFiles/SupportRequestList.vue")
      },
      {
        path: "/communication/supportRequest/new",
        name: "addSupportRequest",
        component: () => import("@/views/communication/createFiles/AddSupportRequest.vue")
      },
      {
        path: "/communication/supportRequest/:id",
        name: "viewSupportRequest",
        component: () => import("@/views/communication/viewFiles/ViewSupportRequest.vue")
      },
      //#endregion supportRequest
      //#region supportRequestCategory
      {
        path: "/communication/supportRequestCategory/list",
        name: "supportRequestCategoryList",
        component: () => import("@/views/communication/listFiles/SupportRequestCategoryList.vue")
      },
      {
        path: "/communication/supportRequestCategory/new",
        name: "addSupportRequestCategory",
        component: () => import("@/views/communication/createFiles/AddSupportRequestCategory.vue")
      },
      {
        path: "/communication/supportRequestCategoryCategory/:id/edit",
        name: "editSupportRequestCategory",
        component: () => import("@/views/communication/editFiles/EditSupportRequestCategory.vue")
      },
      {
        path: "/communication/supportRequestCategory/:id",
        name: "viewSupportRequestCategory",
        component: () => import("@/views/communication/viewFiles/ViewSupportRequestCategory.vue")
      },
      //#endregion supportRequestCategory
      //#region applicationClient
      {
        path: "/settings/applicationClient/list",
        name: "applicationClientList",
        component: () => import("@/views/settings/listFiles/ApplicationClientList.vue")
      },
      {
        path: "/settings/applicationClient/new",
        name: "addApplicationClient",
        component: () => import("@/views/settings/createFiles/AddApplicationClient.vue")
      },
      {
        path: "/settings/applicationClient/:id/edit",
        name: "editApplicationClient",
        component: () => import("@/views/settings/editFiles/EditApplicationClient.vue")
      },
      {
        path: "/settings/applicationClient/:id",
        name: "viewApplicationClient",
        component: () => import("@/views/settings/viewFiles/ViewApplicationClient.vue")
      },
      //#endregion applicationClient
      //#region language
      {
        path: "/settings/language/list",
        name: "languageList",
        component: () => import("@/views/settings/listFiles/LanguageList.vue")
      },
      {
        path: "/settings/language/new",
        name: "addLanguage",
        component: () => import("@/views/settings/createFiles/AddLanguage.vue")
      },
      {
        path: "/settings/language/:id/edit",
        name: "editLanguage",
        component: () => import("@/views/settings/editFiles/EditLanguage.vue")
      },
      {
        path: "/settings/language/:id",
        name: "viewLanguage",
        component: () => import("@/views/settings/viewFiles/ViewLanguage.vue")
      },
      {
        path: "/settings/studioLanguage/list",
        name: "studioLanguageList",
        component: () => import("@/views/settings/listFiles/StudioLanguageList.vue")
      },
      {
        path: "/settings/studioLanguage/new",
        name: "addStudioLanguage",
        component: () => import("@/views/settings/createFiles/AddStudioLanguage.vue")
      },
      {
        path: "/settings/studioLanguage/:id/edit",
        name: "editStudioLanguage",
        component: () => import("@/views/settings/editFiles/EditStudioLanguage.vue")
      },
      //#endregion language
      //#region mailAccount
      {
        path: "/settings/mailAccount/list",
        name: "mailAccountList",
        component: () => import("@/views/settings/listFiles/MailAccountList.vue")
      },
      {
        path: "/settings/mailAccount/new",
        name: "addMailAccount",
        component: () => import("@/views/settings/createFiles/AddMailAccount.vue")
      },
      {
        path: "/settings/mailAccount/:id/edit",
        name: "editMailAccount",
        component: () => import("@/views/settings/editFiles/EditMailAccount.vue")
      },
      {
        path: "/settings/mailAccount/:id",
        name: "viewMailAccount",
        component: () => import("@/views/settings/viewFiles/ViewMailAccount.vue")
      },
      //#endregion mailAccount
      //#region mailTemplate
      {
        path: "/settings/mailTemplate/list",
        name: "mailTemplateList",
        component: () => import("@/views/settings/listFiles/MailTemplateList.vue")
      },
      {
        path: "/settings/mailTemplate/new",
        name: "addMailTemplate",
        component: () => import("@/views/settings/createFiles/AddMailTemplate.vue")
      },
      {
        path: "/settings/mailTemplate/:id/edit",
        name: "editMailTemplate",
        component: () => import("@/views/settings/editFiles/EditMailTemplate.vue")
      },
      {
        path: "/settings/mailTemplate/:id",
        name: "viewMailTemplate",
        component: () => import("@/views/settings/viewFiles/ViewMailTemplate.vue")
      },
      //#endregion mailTemplate
      //#region nonWorkingDay
      {
        path: "/settings/nonWorkingDay/list",
        name: "nonWorkingDayList",
        component: () => import("@/views/settings/listFiles/NonWorkingDayList.vue")
      },
      {
        path: "/settings/nonWorkingDay/new",
        name: "addNonWorkingDay",
        component: () => import("@/views/settings/createFiles/AddNonWorkingDay.vue")
      },
      {
        path: "/settings/nonWorkingDay/:id/edit",
        name: "editNonWorkingDay",
        component: () => import("@/views/settings/editFiles/EditNonWorkingDay.vue")
      },
      {
        path: "/settings/nonWorkingDay/:id/manage",
        name: "manageNonWorkingDay",
        component: () => import("@/views/settings/editFiles/ManageNonWorkingDay.vue")
      },
      {
        path: "/settings/nonWorkingDay/:id",
        name: "viewNonWorkingDay",
        component: () => import("@/views/settings/viewFiles/ViewNonWorkingDay.vue")
      },
      //#endregion nonWorkingDay
      //#region parameter
      {
        path: "/settings/parameter/list",
        name: "parameterList",
        component: () => import("@/views/settings/listFiles/ParameterList.vue")
      },
      {
        path: "/settings/parameter/new",
        name: "addParameter",
        component: () => import("@/views/settings/createFiles/AddParameter.vue")
      },
      {
        path: "/settings/parameter/:id/edit",
        name: "editParameter",
        component: () => import("@/views/settings/editFiles/EditParameter.vue")
      },
      {
        path: "/settings/parameter/:id",
        name: "viewParameter",
        component: () => import("@/views/settings/viewFiles/ViewParameter.vue")
      },
      //#endregion parameter
      //#region translation
      {
        path: "/settings/translation/list",
        name: "translationList",
        component: () => import("@/views/settings/listFiles/TranslationList.vue")
      },
      {
        path: "/settings/translation/new",
        name: "addTranslation",
        component: () => import("@/views/settings/createFiles/AddTranslation.vue")
      },
      {
        path: "/settings/translation/:id/edit",
        name: "editTranslation",
        component: () => import("@/views/settings/editFiles/EditTranslation.vue")
      },
      {
        path: "/settings/translation/:id",
        name: "viewTranslation",
        component: () => import("@/views/settings/viewFiles/ViewTranslation.vue")
      },
      {
        path: "/settings/studioTranslation/list",
        name: "studioTranslationList",
        component: () => import("@/views/settings/listFiles/StudioTranslationList.vue")
      },
      {
        path: "/settings/studioTranslation/new",
        name: "addStudioTranslation",
        component: () => import("@/views/settings/createFiles/AddStudioTranslation.vue")
      },
      {
        path: "/settings/studioTranslation/:key/edit",
        name: "editStudioTranslation",
        component: () => import("@/views/settings/editFiles/EditStudioTranslation.vue")
      },
      //#endregion translation
      //#region program
      {
        path: "/settings/program/list",
        name: "programList",
        component: () => import("@/views/settings/listFiles/ProgramList.vue")
      },
      {
        path: "/settings/program/new",
        name: "addProgram",
        component: () => import("@/views/settings/createFiles/AddProgram.vue")
      },
      {
        path: "/settings/program/:id/edit",
        name: "editProgram",
        component: () => import("@/views/settings/editFiles/EditProgram.vue")
      },
      //#endregion program
      //#region TokenProvider
      {
        path: "/settings/tokenProvider/list",
        name: "tokenProviderList",
        component: () => import("@/views/settings/listFiles/TokenProviderList.vue")
      },
      {
        path: "/settings/tokenProvider/new",
        name: "addTokenProvider",
        component: () => import("@/views/settings/createFiles/AddTokenProvider.vue")
      },
      //#endregion TokenProvider
      //#region TokenRegistry
      {
        path: "/settings/tokenRegistry/list",
        name: "tokenRegistryList",
        component: () => import("@/views/settings/listFiles/TokenRegistryList.vue")
      },
      {
        path: "/settings/tokenRegistry/new",
        name: "addTokenRegistry",
        component: () => import("@/views/settings/createFiles/AddTokenRegistry.vue")
      },
      {
        path: "/settings/tokenRegistry/:id/edit",
        name: "editTokenRegistry",
        component: () => import("@/views/settings/editFiles/EditTokenRegistry.vue")
      },
      //#endregion TokenRegistry
      //#region Document
      {
        path: "/settings/document/list",
        name: "documentList",
        component: () => import("@/views/settings/listFiles/DocumentList.vue")
      },
      {
        path: "/settings/Document/new",
        name: "addDocument",
        component: () => import("@/views/settings/createFiles/AddDocument.vue")
      },
      //#endregion Document
      //#region logging
      {
        path: "/settings/logging/all",
        name: "allLogList",
        component: () => import("@/views/settings/listFiles/LogList.vue")
      },
      {
        path: "/settings/logging/exception",
        name: "exceptionLogList",
        component: () => import("@/views/settings/listFiles/ExceptionLogList.vue")
      },
      {
        path: "/settings/logging/fatalException",
        name: "fatalExceptionLogList",
        component: () => import("@/views/settings/listFiles/FatalExceptionLogList.vue")
      },
      {
        path: "/settings/logging/audit",
        name: "auditLogList",
        component: () => import("@/views/settings/listFiles/AuditLogList.vue")
      },
      {
        path: "/settings/logging/import",
        name: "importLogList",
        component: () => import("@/views/settings/listFiles/ImportLogList.vue")
      },
      //#endregion logging
      //#region Membership
      //#region User
      {
        path: "/membership/user/list",
        name: "userList",
        component: () => import("@/views/membership/listFiles/UserList.vue")
      },
      {
        path: "/membership/user/:id",
        name: "viewUser",
        component: () => import("@/views/membership/viewFiles/ViewUser.vue")
      },
      {
        path: "/membership/user/new",
        name: "addUser",
        component: () => import("@/views/membership/createFiles/AddUser.vue")
      },
      {
        path: "/membership/user/new/ldap",
        name: "addLDAPUser",
        component: () => import("@/views/membership/createFiles/AddLDAPUser.vue")
      },
      {
        path: "/membership/user/new/robot",
        name: "addRobotUser",
        component: () => import("@/views/membership/createFiles/AddRobotUser.vue")
      },
      {
        path: "/membership/user/new/studio",
        name: "addStudioUser",
        component: () => import("@/views/membership/createFiles/AddStudioUser.vue")
      },
      {
        path: "/membership/user/:id/edit",
        name: "editUser",
        component: () => import("@/views/membership/editFiles/EditUser.vue")
      },
      {
        path: "/membership/user/:id/manageRoles",
        name: "manageUserRoles",
        component: () => import("@/views/membership/editFiles/ManageUserRoles.vue")
      },
      {
        path: "/membership/user/:id/manageClaimRestrictions",
        name: "manageClaimRestrictions",
        component: () => import("@/views/membership/editFiles/ManageUserClaims.vue")
      },
      {
        path: '/membership/myprofile',
        name: 'myProfile',
        component: () => import("@/views/membership/Profile.vue")
      },
      //#endregion User
      //#region Role
      {
        path: "/membership/role/list",
        name: "roleList",
        component: () => import("@/views/membership/listFiles/RoleList.vue")
      },
      {
        path: "/membership/role/:id",
        name: "viewRole",
        component: () => import("@/views/membership/viewFiles/ViewRole.vue")
      },
      {
        path: "/membership/role/new",
        name: "addRole",
        component: () => import("@/views/membership/createFiles/AddRole.vue")
      },
      {
        path: "/membership/role/:id/edit",
        name: "editRole",
        component: () => import("@/views/membership/editFiles/EditRole.vue")
      },
      {
        path: "/membership/role/:id/manageClaims",
        name: "manageRoleClaims",
        component: () => import("@/views/membership/editFiles/ManageRoleClaims.vue")
      },
      //#endregion Role
      //#region Company
      {
        path: "/company/list",
        name: "companyList",
        component: () => import("@/views/customerManagement/listFiles/CompanyList.vue")
      },
      {
        path: "/company/new",
        name: "addCompany",
        component: () => import("@/views/customerManagement/createFiles/AddCompany.vue")
      },
      {
        path: "/company/:id",
        name: "viewCompany",
        component: () => import("@/views/customerManagement/viewFiles/ViewCompany.vue")
      },
      {
        path: "/company/:id/edit",
        name: "editCompany",
        component: () => import("@/views/customerManagement/editFiles/EditCompany.vue")
      },
      //#endregion Company
      //#region LicenseType
      {
        path: "/licensing/licenseType/list",
        name: "licenseTypeList",
        component: () => import("@/views/customerManagement/listFiles/LicenseTypeList.vue")
      },
      {
        path: "/licensing/licenseType/new",
        name: "addLicenseType",
        component: () => import("@/views/customerManagement/createFiles/AddLicenseType.vue")
      },
      {
        path: "/licensing/licenseType/:id",
        name: "viewLicenseType",
        component: () => import("@/views/customerManagement/viewFiles/ViewLicenseType.vue")
      },
      {
        path: "/licensing/licenseType/:id/edit",
        name: "editLicenseType",
        component: () => import("@/views/customerManagement/editFiles/EditLicenseType.vue")
      },
      //#endregion LicenseType
      //#region LicenseDefinition
      {
        path: "/licensing/licenseDefinition/list",
        name: "licenseDefinitionList",
        component: () => import("@/views/customerManagement/listFiles/LicenseDefinitionList.vue")
      },
      {
        path: "/licensing/licenseDefinition/new",
        name: "addLicenseDefinition",
        component: () => import("@/views/customerManagement/createFiles/AddLicenseDefinition.vue")
      },
      {
        path: "/licensing/licenseDefinition/:id",
        name: "viewLicenseDefinition",
        component: () => import("@/views/customerManagement/viewFiles/ViewLicenseDefinition.vue")
      },
      {
        path: "/licensing/licenseDefinition/:id/edit",
        name: "editLicenseDefinition",
        component: () => import("@/views/customerManagement/editFiles/EditLicenseDefinition.vue")
      },
      //#endregion LicenseDefinition
      //#region CompanyLicense
      {
        path: "/licensing/companyLicense/new/:companyId",
        name: "addCompanyLicense",
        component: () => import("@/views/customerManagement/createFiles/AddCompanyLicense.vue")
      },
      {
        path: "/licensing/companyLicense/:id",
        name: "viewCompanyLicense",
        component: () => import("@/views/customerManagement/viewFiles/ViewCompanyLicense.vue")
      },
      {
        path: "/licensing/companyLicense/:id/edit",
        name: "editCompanyLicense",
        component: () => import("@/views/customerManagement/editFiles/EditCompanyLicense.vue")
      },
      {
        path: "/licensing/companyLicense/:id/consumptions",
        name: "viewConsumption",
        component: () => import("@/views/customerManagement/viewFiles/ViewConsumption.vue")
      }
    ]
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: () => import("@/views/SignIn.vue")
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: () => import("@/views/ResetPassword.vue")
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/error/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/error/Error500.vue"),
  },
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/error/Error401.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to: RouteLocationNormalized) => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);
  store.commit(Mutations.SET_IS_DASHBOARD, false);

  store.dispatch(Actions.INIT_DASHBOARD_STATISTICS);
  store.commit(Mutations.SET_PAGE, 1);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

router.afterEach((to: RouteLocationNormalized) => {
  initConnection();
});

export default router;
